'use client';
import * as __WEBPACK_EXTERNAL_MODULE_react__ from "react";
import * as __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__ from "@nestle-npus-nbm/purina-auth";
import * as __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_3e3773ab__ from "../../../common/functions.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__useGetUser_mjs_9017dd81__ from "./useGetUser.mjs";
import * as __WEBPACK_EXTERNAL_MODULE__useGetCognitoUser_mjs_d214c932__ from "./useGetCognitoUser.mjs";
const useProfileValidations = (config, skipUserFetchIfTandCAccepted = true)=>{
    const { attributes } = (0, __WEBPACK_EXTERNAL_MODULE__useGetCognitoUser_mjs_d214c932__.useGetCognitoUser)(config);
    const [isCompleted, setIsCompleted] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState(true);
    const [shouldCompleteProfileOpen, setShouldCompleteProfileOpen] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState(false);
    const [neededValidations, setNeededValidations] = __WEBPACK_EXTERNAL_MODULE_react__["default"].useState({
        hasTandC: true,
        hasZipcode: true
    });
    const { user: userData } = (0, __WEBPACK_EXTERNAL_MODULE__useGetUser_mjs_9017dd81__.useGetUser)(config, skipUserFetchIfTandCAccepted);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (userData) {
            const incomplete = {
                hasTandC: false,
                hasZipcode: false
            };
            Object.keys(__WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.userValidations).every((key)=>{
                const completed = __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.userValidations[key](attributes, userData);
                incomplete[key] = completed;
                return completed;
            });
            setNeededValidations(incomplete);
        } else if (attributes) {
            const hasTandC = __WEBPACK_EXTERNAL_MODULE__nestle_npus_nbm_purina_auth_11a881f8__.userValidations.hasTandC(attributes, userData);
            setNeededValidations({
                ...neededValidations,
                hasTandC
            });
            setShouldCompleteProfileOpen(!hasTandC);
        }
    }, [
        userData,
        attributes
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        setIsCompleted(Object.values(neededValidations).every((v)=>v));
    }, [
        neededValidations
    ]);
    __WEBPACK_EXTERNAL_MODULE_react__["default"].useEffect(()=>{
        if (isCompleted) setShouldCompleteProfileOpen(false);
        else {
            setShouldCompleteProfileOpen(true);
            (0, __WEBPACK_EXTERNAL_MODULE__common_functions_mjs_3e3773ab__.sendIt)({
                event: 'form_start',
                eventParams: {
                    form_name: 'create account opt-in',
                    form_type: 'sign-up',
                    form_brand: config.analytics?.formBrand ?? '[not set]',
                    form_id: config?.analytics?.loginSourceCode ?? '[not set]',
                    form_version: 'v1'
                }
            }, config.pup.dataLayerName, config.pup.logging);
        }
    }, [
        config,
        isCompleted
    ]);
    return {
        neededValidations,
        shouldCompleteProfileOpen
    };
};
export { useProfileValidations };
